import { route, string } from 'react-router-typesafe-routes/dom'
const base = 'et/company/:companyId/exportModule' as const
const companyOnly = { companyId: string().defined() }

export const REPORT_ROUTES = {
  reportsList: route(base, { params: companyOnly }),
  imiList: route(`${base}/imi`, { params: companyOnly }),
  imiDeclarations: route(`${base}/imi-declarations`, { params: companyOnly }),
  imiAdd: route(`${base}/imi-add`, { params: companyOnly }),
}
